import React from 'react';
import { SvgIcon } from '@mui/material';
import { shape } from 'prop-types';

const MagellanLogoColoredMobile = props => (
  <SvgIcon classes={props.classes} height="26" viewBox="0 0 28 26" width="28">
    <path
      clipRule="evenodd"
      d="M0 0V18.1707L8.49032 7.44132L14.9014 14.45L19.4065 9.95061L27.7235 20.7665V0H0Z"
      fill="#267E4D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M0 20.2471V25.9578H3.98525L13.8618 15.2285L9.18341 12.1135L0 20.2471Z"
      fill="#267E4D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.93088 25.9578H27.7235V21.891L21.1392 17.3051L6.93088 25.9578Z"
      fill="#267E4D"
      fillRule="evenodd"
    />
  </SvgIcon>
);
MagellanLogoColoredMobile.propTypes = {
  classes: shape({}),
};

MagellanLogoColoredMobile.defaultProps = {
  classes: {},
};

export default MagellanLogoColoredMobile;
